import {useCallback, useMemo, useState} from 'react'

function useTrackingActiveAreaProvider() {
  const [isFocus, setIsFocus] = useState<boolean>(false)
  const [isHover, setIsHover] = useState<boolean>(false)
  const handlerParentFocusBlur = useCallback(() => setIsFocus(state => !state), [])
  const handlerParentMouseEnterLeave = useCallback(() => setIsHover(state => !state), [])
  const isActiveArea = isFocus || isHover
  const value = useMemo(
    () => ({
      isActiveArea,
    }),
    [isActiveArea],
  )

  return {
    handlerParentFocusBlur,
    handlerParentMouseEnterLeave,
    value,
  }
}

export default useTrackingActiveAreaProvider
